import { createContext } from 'react'
import { Pin, TimelineEvent } from '@towns-protocol/sdk'
import { useHandleReaction } from 'hooks/useReactions'
import { Channel, useTimelineThreadStats, useTownsClient } from 'use-towns-client'

import { useTimelineMessageEditing } from './hooks/useTimelineMessageEditing'

export enum MessageTimelineType {
    Channel = 'channel',
    Thread = 'thread',
}

export const MessageTimelineContext = createContext<{
    userId: string | undefined
    spaceId: string | undefined
    channelId: string
    isChannelEncrypted?: boolean
    isChannelWritable?: boolean
    isChannelPinnable?: boolean
    isChannelReactable?: boolean
    threadParentId?: string
    channels: Channel[]
    events: TimelineEvent[]
    type: MessageTimelineType
    messageRepliesMap: ReturnType<typeof useTimelineThreadStats>
    timelineActions: ReturnType<typeof useTimelineMessageEditing>
    handleReaction?: ReturnType<typeof useHandleReaction>
    sendReadReceipt: ReturnType<typeof useTownsClient>['sendReadReceipt']
    memberIds: string[]
    onMentionClick?: (mentionName: string) => void
    pins: Pin[] | undefined
} | null>(null)
